'use client';

import { FC } from 'react';
import NumberInput from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import russianLabels from 'react-phone-number-input/locale/ru';
import 'react-phone-number-input/style.css';

import styles from './styles.module.css';

interface Props {
  error?: string | null;
  onChange?: (val?: string) => void;
  value?: string;
}

const PhoneInput: FC<Props> = ({ error, ...inputProps }) => {
  const { onChange, value } = inputProps;

  const handleChange = (val?: string) => {
    if (onChange) {
      onChange(val);
    }
  };

  return (
    <div className={styles.container}>
      {error && <div className={styles.error}>{error}</div>}
      <NumberInput
        placeholder="Введите номер телефона"
        className={styles.input}
        labels={russianLabels}
        withCountryCallingCode
        onChange={handleChange}
        value={value}
        defaultCountry="RU"
        international
        flags={flags}
        countryCallingCodeEditable={false}
        limitMaxLength={true}
      />
    </div>
  );
};

export default PhoneInput;
